import { getRelativeWidth } from '../../config';
import { LandingpageImageContainer } from '../../assets/ts/pages/landingpage';
import { LandingpageHexagonImage } from './LandingpageHexagonImage';

export function LandingpageImage({
    offsetLeft,
    offsetTop,
    width,
    position,
    src,
    imgWidth = 900,
    imgHeight = 600,
    isBig = false,
}: {
    offsetLeft: number;
    offsetTop: number;
    width: number;
    position: number;
    src: string;
    imgWidth?: number;
    imgHeight?: number;
    isBig?: boolean;
}) {
    const delay = 0.5 + position * 0.1;

    return (
        <LandingpageImageContainer
            offsetLeft={offsetLeft}
            offsetTop={offsetTop}
            width={getRelativeWidth(width)}
            delay={delay}
        >
            <LandingpageHexagonImage imgHeight={imgHeight} imgWidth={imgWidth} src={src} big={isBig} />
        </LandingpageImageContainer>
    );
}
